let lalghati_to_clg = [
    [77.37206391372973, 23.27246751005991], [77.37281159420826, 23.27258978898152],
    [77.37505588478172, 23.272264084096633], [77.38068191223931, 23.26528868918355],
    [77.39338929925452, 23.260542238140204], [77.3952726511518, 23.259411510002252],
    [77.39843356848985, 23.259006297562905], [77.39836654105005, 23.252343681629867],
    [77.39585296474206, 23.249948089671392], [77.39725097363458, 23.246229541800773],
    [77.39690777492393, 23.244427604640563], [77.40122002916138, 23.24224297226972],
    [77.4074606873217, 23.245721454783123], [77.40887529562508, 23.245770126342308],
    [77.40890504601708, 23.24762891145288], [77.41053716334358, 23.249816811285143],
    [77.41281370772788, 23.24895285707332], [77.41053223603956, 23.244059026645076],
    [77.40657061173533, 23.241411678398464], [77.40139279747984, 23.237357474266815],
    [77.38848778803276, 23.227589380611036], [77.382194886035, 23.2211809926075],
    [77.37968451166967, 23.215028829460564], [77.37773199827598, 23.20887638296547],
    [77.37034034042563, 23.208491845653185], [77.36769050082012, 23.204518228627876],
    [77.35834632957608, 23.20336457574936], [77.35109413696767, 23.19721159223245],
    [77.34862928190631, 23.194936851940213], [77.34261223644734, 23.19295146181885],
    [77.3359780581186, 23.187704217465992], [77.32132115251119, 23.170117357269348],
    [77.32464443312125, 23.168229558503768], [77.3264361013637, 23.168084219302614],
    [77.32886012310274, 23.165613428747434], [77.3302992700385, 23.166035667629373]
];
let anand_nagar_to_clg = [
    [77.50986760114057, 23.25295059516185], [77.50346791559599, 23.25229828148946],
    [77.50084452904997, 23.249568455536163], [77.48890396596227, 23.249036823995795],
    [77.48569526839248, 23.252081594124988], [77.47601285233998, 23.2493879555645],
    [77.47220599977061, 23.249138118278097], [77.44688802283883, 23.252940419267688],
    [77.43490160260274, 23.252963500055913], [77.43068079065665, 23.252198829943865],
    [77.42958430790816, 23.256883947279633], [77.43175103608974, 23.259162757960738],
    [77.424433600322, 23.264426342269658], [77.42230965717891, 23.2648165915233],
    [77.41852195857336, 23.262995418561218], [77.41504864183474, 23.263159376109087],
    [77.41313127311594, 23.263746537363886], [77.41363683524071, 23.261760034431973],
    [77.41001439386531, 23.260553533968817], [77.40872878525079, 23.261494416796182],
    [77.4099054439817, 23.263095904206153], [77.41099494280871, 23.26281564529843],
    [77.41031478652582, 23.25887544750421], [77.41024812836571, 23.25703820919348],
    [77.40887445010321, 23.254806284618112], [77.41176472091229, 23.254057752107443],
    [77.41417246060433, 23.252230317314826], [77.41281370772788, 23.24895285707332]
];

let kjl_to_clg = [
    [77.40063048496978, 23.10750732641519],
    [77.41406113026335, 23.160877470353668],
    [77.41728870247374, 23.174447557984664],
    [77.41700890809909, 23.18967399896887],
    [77.41675336053686, 23.203849276983135],
    [77.41882634624045, 23.210103252895394],
    [77.41914590278049, 23.213621019861193],
    [77.41703610420723, 23.217283511580916],
    [77.41061293966214, 23.22047195201391],
    [77.40503369454558, 23.221419852058645],
    [77.3971657857291, 23.217649762199883],
    [77.39306145633918, 23.21323004697497],
    [77.39127876781686, 23.211934585491306],
    [77.38729881204557, 23.21201078945579],
    [77.38421752380248, 23.2138724103976],
    [77.38298745778434, 23.215191296968825],
    [77.37977350347109, 23.215227017780094]
]



const routes = {
  route1: {coords:lalghati_to_clg, color:"#6004ff"},
  route2: {coords:anand_nagar_to_clg, color:"#ff3a04"},
  route3: {coords:kjl_to_clg, color:"#3fff04"}
};
 

export default routes;
